import React, { useState } from 'react'
import styled from 'styled-components'
import {
  FormGroup, Input, InputProps, FormFeedback,
} from 'reactstrap'
import colors from 'constants/colors'
import { AutoComplete } from 'antd'
import StyledLabel from './Label'

const StyledFormGroup = styled(FormGroup)`
  margin-bottom: 22px;
`

const inputStyles = `
  color: ${colors.black} !important;
  background-color: ${colors.inputGrey} !important;
  border: 0 !important;
  border-radius: 7px !important;
  font-weight: 500 !important;
  font-family: Poppins !important;

  ::placeholder {
    color: ${colors.inputTextGrey};
    opacity: 1;
  }

  :-ms-input-placeholder {
    color: ${colors.inputTextGrey};
  }

  ::-ms-input-placeholder {
    color: ${colors.inputTextGrey};
  }

  &:focus {
    ::placeholder {
      color: ${colors.inputFocusedPlaceholder};
      opacity: 1;
    }
    
    :-ms-input-placeholder {
      color: ${colors.inputFocusedPlaceholder};
    }
    
    ::-ms-input-placeholder {
      color: ${colors.inputFocusedPlaceholder};
    }
  }
`

const StyledInput = styled(Input)`${inputStyles}`

const AutoCompleteField = styled(AutoComplete)`
  .ant-select-selector{
    ${inputStyles}

    height: calc(1.5em + .75rem + 2px) !important;
    padding: 0.21rem .75rem .375rem .75rem !important;
    font-size: 1rem !important;
    line-height: 1.5 !important;
    background-clip: padding-box !important;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;

    input {
      height: 35px !important;
    }
  }
`

type FormFieldProps = InputProps & {
  label?: string,
  feedback?: string,
}

const FormField = ({
  label, id, name, feedback, children, ...addlInputProps
}: FormFieldProps) => {
  const forId = id || name

  return (
    <StyledFormGroup>
      <StyledLabel for={forId}>{label}</StyledLabel>
      <StyledInput id={forId} name={name} {...addlInputProps}>
        {children}
      </StyledInput>
      <FormFeedback>{feedback}</FormFeedback>
    </StyledFormGroup>
  )
}

type AutoCompleteFormFieldProps = InputProps & {
  label?: string,
  feedback?: string,
  options?: {value: string}[],
  onSearch?: (searchText: string) => void,
  style?: any
}

export const AutoCompleteFormField = ({
  label, options, onSearch, feedback, style,
}: AutoCompleteFormFieldProps) => {
  const [autocompleteDisabled, setAutocompleteDisabled] = useState(false)

  return (
    <StyledFormGroup>
      <StyledLabel>{label}</StyledLabel>
      <AutoCompleteField
        options={options}
        style={style}
        onChange={onSearch}
        placeholder="search"
        filterOption={(inputValue, option) => {
          if (option) return option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          return false
        }}
        onFocus={() => {
          // Only fix till addressed by Antd maintainers for removing chromes autocomplete
          // https://github.com/ant-design/ant-design/issues/7659#issuecomment-580688874
          if (!autocompleteDisabled) {
            document.querySelectorAll('.ant-select-selector input').forEach((e) => {
              e.setAttribute('autocomplete', 'dontshow')
              e.setAttribute('id', `new${Math.random()}`)
            })
            setAutocompleteDisabled(true)
          }
        }}
      />
      <div className="invalid-feedback" style={{ display: 'block' }}>{feedback}</div>
    </StyledFormGroup>
  )
}

export default FormField
